import {PureComponent} from 'react'
import {Card, CardBody, CardImg, CardTitle} from 'reactstrap'
import PropTypes from 'prop-types'

import aeroEngineer from './images/aeroEngineer.png'
import capexPurchaser from './images/capexPurchaser.jpg'
import cfo from './images/cfo.jpg'
import chro from './images/chro.jpg'
import consolidationManager from './images/consolidationManager.jpg'
import businessController from './images/businessController.jpg'
import indirectPurchaser from './images/indirectPurchaser.jpg'
import isHrProjectManager from './images/isHrProjectManager.jpg'
import payrollManager from './images/payrollManager.jpg'
import purchaseManager from './images/purchaseManager.jpg'
import qualityEngineer from './images/qualityEngineer.png'
import recruitmentManager from './images/recruitmentManager.jpg'
import supplyChainManager from './images/supplyChainManager.jpg'
import treasuryManager from './images/treasuryManager.jpg'

import './FreelanceExamples.scss'

const freelances = [
  {img: indirectPurchaser.src, title: 'Contract Manager Achats', universe: 'purchase', alt: 'Photo d\'un consultant freelance'},
  {img: capexPurchaser.src, title: 'Acheteur International', universe: 'purchase', alt: 'Photo d\'une consultante en achat industriels'},
  {img: supplyChainManager.src, title: 'Responsable Supply Chain', universe: 'purchase', alt: 'Photo d\'un consultant responsable supply chain logistique avec le sourire'},
  {img: purchaseManager.src, title: 'Responsable Achats', universe: 'purchase', alt: 'Photo d\'un consultant responsable achat stratégique au téléphone'},
  {img: businessController.src, title: 'Contrôleur de Gestion', universe: 'finance', alt: 'Consultante souriante experte en contrôle de gestion opérationnel'},
  {img: cfo.src, title: 'Responsable Administratif et Financier', universe: 'finance', alt: 'Photo d\'un consultant experimenté en DAF stratégique'},
  {img: treasuryManager.src, title: 'Responsable Trésorerie', universe: 'finance', alt: 'Profil d\'un consultant responsable trésorie stratégique'},
  {img: consolidationManager.src, title: 'Responsable Consolisation', universe: 'finance', alt: 'Consultant experimenté en consolidation et optimisation des processus financiers'},
  {img: payrollManager.src, title: 'Responsable de Paie', universe: 'hr', alt: 'Photo d\'une consultante freelance junior'},
  {img: chro.src, title: 'Directeur des Ressources Humaines', universe: 'hr', alt: 'Profil d\'une consultante en ressources humaines'},
  {img: isHrProjectManager.src, title: 'Responsable Formation', universe: 'hr', alt: 'Photo de profil d\'un consultant senior'},
  {img: recruitmentManager.src, title: 'Responsable Relations Sociales', universe: 'hr', alt: 'Photo d\'une consultante freelance senior en recrutement'},
  {img: indirectPurchaser.src, title: 'Ingénieur Maintenance', universe: 'engineering', alt: 'Photo d\'un consultant freelance'},
  {img: payrollManager.src, title: 'Ingénieur Technique', universe: 'engineering', alt: 'Photo d\'une consultante freelance junior'},
  {img: qualityEngineer.src, title: 'Ingénieur Qualité', universe: 'engineering', alt: 'Photo d\'une consultante expertisée en qualité produit'},
  {img: aeroEngineer.src, title: 'Ingénieur Aéronautique', universe: 'engineering', alt: 'Photo d\'une consultante ingénieur en qualité production'},
]

const freelancesHomepage = [
  {img: indirectPurchaser.src, title: 'Ingénieur Industrialisation', universe: 'purchase', alt: 'Photo d\'un consultant freelance'},
  {img: capexPurchaser.src, title: 'Acheteur Industriel et Capex', universe: 'purchase', alt: 'Photo d\'une consultante en achat industriels'},
  {img: supplyChainManager.src, title: 'Responsable Supply Chain', universe: 'purchase', alt: 'Photo d\'un consultant responsable supply chain logistique avec le sourire'},
  {img: purchaseManager.src, title: 'Responsable Achats', universe: 'purchase', alt: 'Photo d\'un consultant responsable achat stratégique au téléphone'},
  {img: businessController.src, title: 'Contrôleur de Gestion', universe: 'finance', alt: 'Consultante souriante experte en contrôle de gestion opérationnel'},
  {img: cfo.src, title: 'Responsable Administratif et Financier', universe: 'finance', alt: 'Photo d\'un consultant experimenté en DAF stratégique'},
  {img: payrollManager.src, title: 'Ingénieur Logistique', universe: 'hr', alt: 'Photo d\'une consultante freelance junior'},
  {img: chro.src, title: 'Directeur des Ressources Humaines', universe: 'hr', alt: 'Profil d\'une consultante en ressources humaines'},
]

export default class FreelanceExamples extends PureComponent {
  static propTypes = {
    universeCode: PropTypes.string
  }

  static defaultProps = {
    universeCode: null,
  }

  render() {
    const universeCode = this.props.universeCode
    const filteredFeelances = (
      universeCode
        ? freelances.filter(freelance => freelance.universe === universeCode).slice(0, 4)
        : freelancesHomepage
    )

    return <section className="freelance-examples container text-center py-5">
      <h2 className="mb-5">Les profils les plus demandés</h2>
      <ul className="row">
        {filteredFeelances.map((freelance, index) => (
          <Card className="col-6 col-md-3 px-4 px-md-5 bg-transparent" key={index} tag="li">
            <CardImg className="border border-white" src={freelance.img} alt={freelance.alt || ''}/>
            <CardBody>
              <CardTitle tag="h3">{freelance.title}</CardTitle>
            </CardBody>
          </Card>
        ))}
      </ul>
    </section>
  }
}
